import axios from "axios";
import { useURL } from "../data/Config";
import { IActivity } from "../types";

export const getLatestActivities = async (): Promise<IActivity[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get<{ activities: IActivity[] }>(
    `${useURL}/activities/latest-activities`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.activities;
};
